module.exports = __webpack_public_path__ + "aws.icon.a1be6.svg";